var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-menu-drop-area",style:([_vm.size])},[_vm._l((_vm.maxMenuItemsPerView),function(count,index){return _c('b-menu-drop-target',{key:index,attrs:{"index":index}})}),_c('b-menu-drop-target-indicator')],2)}
var staticRenderFns = []

export { render, staticRenderFns }